import { get, postJson } from '../../../hook/request';

export type NotificationData = {
  ID: number;
  userID: number;
  type: string;
  text: string;
  link_at: string;
  read_in: 0 | 1;
  read_at: string | null;
  created_at: string;
};
export type NotificationResponse = { list: NotificationData[] };
export const notificationsKey = ['notifications'] as const;

export async function getNotifications(): Promise<NotificationResponse> {
  const response = await get<NotificationResponse>('/notification/all');
  return { list: Array.isArray(response.data?.list) ? response.data.list : [] };
}

const pendingReads = new Map<number, Promise<void>>();
export function readNotification(ID: number): Promise<void> {
  const pending = pendingReads.get(ID);
  if (pending) return pending;
  const request = (async () => {
    const response = await postJson<{ success: boolean }>(
      '/notification/read?ID=' + encodeURIComponent(String(ID)), {}
    );
    if (!response.data?.success) throw new Error('Impossibile segnare la notifica come letta.');
  })();
  pendingReads.set(ID, request);
  request.then(() => pendingReads.delete(ID), () => pendingReads.delete(ID));
  return request;
}

export function notificationPath(link: string): string {
  try {
    const path = new URL(link, window.location.origin).pathname.replace(/\/$/, '');
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return base && path.startsWith(base + '/') ? path.slice(base.length) : path;
  } catch { return ''; }
}
